const defaultSettings = [
  { chart: "orderChart", value: true, label: "نمودار سفارشات" },
  { chart: "customerOrderChart", value: true, label: "نمودار سفارشات" },
  { chart: "customerChart", value: true, label: "نمودار مشتریان" },
  { chart: "orderHourChart", value: true, label: "نمودار ساعتی سفارشات" },
  // { chart: "invoiceChart", value: false, label: "نمودار فاکتورها" },
  { chart: "designerChart", value: true, label: "نمودار طراحان" },
  { chart: "damagePlateChart", value: true, label: "نمودار خرابی" },
  { chart: "productionChart", value: true, label: "نمودار تولید" },
  { chart: "priceChart", value: true, label: "نمودار قیمت ها" },
  { chart: "compareChart", value: true, label: "نمودار مقایسه ای" },
  { chart: "saleExpertChart", value: true, label: "نمودار  کارشناسان فروش" },
  {
    chart: "designerTimeChart",
    value: true,
    label: "گزارش مدت زمان طراحی (طراح)",
  },
  {
    chart: "customerTimeChart",
    value: true,
    label: "گزارش مدت زمان طراحی (مشتری)",
  },
  { chart: "orderTypeChart", value: true, label: "تناسب نوع سفارش" },
  {
    chart: "productionPlateChart",
    value: true,
    label: "تناسب نوع کلیشه",
  },
    { chart: "accountChart", value: true, label: "نمودار مجموع حساب ها" },
  { chart: "transactionChart", value: true, label: "نمودار ثبت تراکنش ها" },
  { chart: "chequeChart", value: true, label: "نمودار سررسید چک ها" },

];

const AccordionCharts = [
  { chart: "orderChart", value: true },
  { chart: "customerOrderChart", value: true },
  { chart: "customerChart", value: true },
  { chart: "orderHourChart", value: true },
  // { chart: "invoiceChart", value: true },
  { chart: "designerChart", value: true },
  { chart: "damagePlateChart", value: true },
  { chart: "productionChart", value: true },
  { chart: "priceChart", value: true },
  { chart: "compareChart", value: true },
  { chart: "saleExpertChart", value: true },
  { chart: "designerTimeChart", value: true },
  { chart: "customerTimeChart", value: true },
  { chart: "orderTypeChart", value: true },
  { chart: "productionPlateChart", value: true },
    { chart: "accountChart", value: true },
  { chart: "transactionChart", value: true },
  { chart: "chequeChart", value: true },

];
export { defaultSettings, AccordionCharts };
